export const CREATE_OBJECTIVE = 'CREATE_OBJECTIVE'
export const EDIT_OBJECTIVE = 'EDIT_OBJECTIVE'
export const CREATE_KEY_RESULT = 'CREATE_KEY_RESULT'
export const EDIT_KEY_RESULT = 'EDIT_KEY_RESULT'
export const EDIT_PERSONAL_OBJECTIVE = 'EDIT_PERSONAL_OBJECTIVE'
export const EDIT_ORGANIZATIONAL_OBJECTIVE = 'EDIT_ORGANIZATIONAL_OBJECTIVE'
